import { Solcelledetaljer } from '../../../../../../types/registration/userInput';
import { SolcellerFormData } from '../../types';

/**
 * Converts Solcelledetaljer from UserInput to SolcellerFormData for form initialization.
 * Maps unified soner array to kwpPanels/sqmPanels based on whether effektKWp or aktivtAreal/takAreal is set.
 */
export const userInputToSolcellerFormData = (
  solcelledetaljer?: Solcelledetaljer
): SolcellerFormData | undefined => {
  if (!solcelledetaljer) {
    return undefined;
  }

  const kwpPanels: Array<{ effect?: number; tilt?: number; azimuth?: number }> = [];
  const sqmPanels: Array<{
    panelType?: 'solcelletakstein' | 'solcellepanel';
    area?: number;
    hasActivePanelArea?: 'yes' | 'no';
    roofArea?: number;
    tilt?: number;
    azimuth?: number;
  }> = [];

  for (const sone of solcelledetaljer.soner ?? []) {
    if (sone.effektKWp != null) {
      kwpPanels.push({
        effect: sone.effektKWp,
        tilt: sone.helling,
        azimuth: sone.azimut
      });
    } else {
      sqmPanels.push({
        panelType: sone.panelType,
        area: sone.aktivtAreal,
        hasActivePanelArea:
          sone.aktivtAreal != null ? 'yes' : sone.takAreal != null ? 'no' : undefined,
        roofArea: sone.takAreal,
        tilt: sone.helling,
        azimuth: sone.azimut
      });
    }
  }

  const hasCapacityData =
    kwpPanels.length > 0 ? 'yes' : sqmPanels.length > 0 ? 'no' : undefined;

  const productionData =
    solcelledetaljer.produsertKwh != null
      ? 'actualProduction'
      : solcelledetaljer.beregnetKwh != null
        ? 'calculatedProduction'
        : 'unknown';
  const sharedSolarInstallation = solcelledetaljer.deltAnlegg ? 'yes' : 'no';
  const sharedSolarDistribution =
    solcelledetaljer.deltAnlegg && solcelledetaljer.totaltAntallBoenheterSomDeler
      ? 'equal'
      : solcelledetaljer.deltAnlegg
        ? 'percentage'
        : undefined;
  const productionDataScope =
    solcelledetaljer.produksjonsdataGjelder === 'denneBoenheten'
      ? 'thisBoenhet'
      : solcelledetaljer.produksjonsdataGjelder === 'heleAnlegget'
        ? 'wholeInstallation'
        : undefined;

  const formData: SolcellerFormData = {
    installationYear: solcelledetaljer.installasjonsAr,
    sharedSolarInstallation,
    sharedSolarDistribution,
    totalSharedBoenheter: solcelledetaljer.totaltAntallBoenheterSomDeler,
    fordelingsnokkelPercent:
      solcelledetaljer.fordelingsnokkel != null
        ? solcelledetaljer.fordelingsnokkel * 100
        : undefined,
    productionDataScope,
    productionData,
    producedKwh: solcelledetaljer.produsertKwh,
    calculatedKwh: solcelledetaljer.beregnetKwh,
    latitude: solcelledetaljer.latitude,
    longitude: solcelledetaljer.longitude,
    hasCapacityData, // This indicates whether or not kwp panels are to be defined
    sqmPanels: sqmPanels.length > 0 ? sqmPanels : undefined,
    kwpPanels: kwpPanels.length > 0 ? kwpPanels : undefined
  };

  return formData;
};
